import { render, staticRenderFns } from "./description.vue?vue&type=template&id=f636f45c&lang=pug&"
import script from "./description.vue?vue&type=script&lang=js&"
export * from "./description.vue?vue&type=script&lang=js&"
import style0 from "./description.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f636f45c')) {
      api.createRecord('f636f45c', component.options)
    } else {
      api.reload('f636f45c', component.options)
    }
    module.hot.accept("./description.vue?vue&type=template&id=f636f45c&lang=pug&", function () {
      api.rerender('f636f45c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/description.vue"
export default component.exports